import { Link, useSearchParams } from "react-router-dom"
import styles from "./Pagination.module.css"

interface Props {
  page: number
  totalPages: number
}

export function Pagination({ page, totalPages }: Props) {
  const [searchParams] = useSearchParams()
  const pages = buildPageNumbers(page, totalPages)

  function pageUrl(p: number) {
    const next = new URLSearchParams(searchParams)
    if (p <= 1) next.delete("page")
    else next.set("page", String(p))
    const qs = next.toString()
    return qs ? `?${qs}` : "?"
  }

  function scrollToTop() {
    window.scrollTo({ top: 0 })
  }

  return (
    <div className={styles.wrap}>
      <span className={styles.pageStatus}>
        {page} / {totalPages} ページ
      </span>
      <nav className={styles.nav} aria-label="ページネーション">
        {page === 1 ? (
          <span className={`${styles.btn} ${styles.disabled}`}>前へ</span>
        ) : (
          <Link className={styles.btn} to={pageUrl(page - 1)} onClick={scrollToTop}>
            前へ
          </Link>
        )}

        {pages.map((p, i) =>
          p === "..." ? (
            // biome-ignore lint/suspicious/noArrayIndexKey: ellipsis positions are stable
            <span key={`ellipsis-${i}`} className={styles.ellipsis}>
              ...
            </span>
          ) : (
            <Link
              key={p}
              className={`${styles.btn} ${p === page ? styles.active : ""}`}
              to={pageUrl(p as number)}
              onClick={scrollToTop}
            >
              {p}
            </Link>
          )
        )}

        {page === totalPages ? (
          <span className={`${styles.btn} ${styles.disabled}`}>次へ</span>
        ) : (
          <Link className={styles.btn} to={pageUrl(page + 1)} onClick={scrollToTop}>
            次へ
          </Link>
        )}
      </nav>
    </div>
  )
}

function buildPageNumbers(current: number, total: number): (number | "...")[] {
  if (total <= 7) {
    return Array.from({ length: total }, (_, i) => i + 1)
  }
  const pages: (number | "...")[] = [1]
  if (current > 3) pages.push("...")
  for (let i = Math.max(2, current - 1); i <= Math.min(total - 1, current + 1); i++) {
    pages.push(i)
  }
  if (current < total - 2) pages.push("...")
  pages.push(total)
  return pages
}
